const dataManagementEntities = {
    PROJECT: 'PROJECT',
    TEMPLATE: 'TEMPLATE',
};

export default dataManagementEntities;
